var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { msg, localized } from '@lit/localize';
let InputText = class InputText extends LitElement {
    constructor() {
        super(...arguments);
        this.placeholder = '';
        this.special = false;
        this.value = '';
        this.size = 'medium';
        this.variant = 'primary';
    }
    handleInput(e) {
        const target = e.target;
        this.value = target.value;
        this.dispatchEvent(new CustomEvent('input-text', {
            detail: this.value,
            bubbles: true,
            composed: true,
        }));
    }
    render() {
        const variantClass = `text-input--${this.variant}`;
        const sizeClass = `text-input--${this.size}`;
        const specialClass = this.special ? 'text-input--special' : '';
        return html `
      <input
        class="text-input ${variantClass} ${sizeClass} ${specialClass}"
        type="text"
        .value=${this.value}
        placeholder=${this.placeholder || msg('Text input...', { id: 'form.placeholder.textInput', desc: 'Text input placeholder' })}
        @input=${this.handleInput}
      />
    `;
    }
};
InputText.styles = css `
    .text-input {
      padding: 8px 12px;
      border: 1px solid #ddd;
      border-radius: 8px;
      font-size: 14px;
      width: 100%;
      box-sizing: border-box;
      transition: border 0.3s, box-shadow 0.3s, background-color 0.3s;
    }

    .text-input:focus {
      border-color: #0078d4;
      box-shadow: 0 0 0 3px rgba(0, 120, 212, 0.2);
      outline: none;
    }

    /* Variants */
    .text-input--primary {
      border-color: #0078d4;
    }

    .text-input--secondary {
      border-color: #6c757d;
    }

    .text-input--success {
      border-color: #28a745;
    }

    .text-input--danger {
      border-color: #dc3545;
    }

    .text-input--warning {
      border-color: #ffc107;
    }

    /* Sizes */
    .text-input--small {
      font-size: 12px;
      padding: 6px 10px;
    }

    .text-input--medium {
      font-size: 14px;
      padding: 8px 12px;
    }

    .text-input--large {
      height: 47px;
      font-size: 20px;
      line-height: 1.5;
      padding: 0 14px;
    }

    /* Special styles */
    .text-input--special {
      background-color: rgba(0, 120, 212, 0.1); /* Default special background */
    }

    .text-input--special.text-input--primary {
      background-color: rgba(0, 120, 212, 0.1);
    }

    .text-input--special.text-input--secondary {
      background-color: rgba(108, 117, 125, 0.1);
    }

    .text-input--special.text-input--success {
      background-color: rgba(40, 167, 69, 0.1);
    }

    .text-input--special.text-input--danger {
      background-color: rgba(220, 53, 69, 0.1);
    }

    .text-input--special.text-input--warning {
      background-color: rgba(255, 193, 7, 0.1);
    }
  `;
__decorate([
    property({ type: String })
], InputText.prototype, "placeholder", void 0);
__decorate([
    property({ type: Boolean })
], InputText.prototype, "special", void 0);
__decorate([
    property({ type: String })
], InputText.prototype, "value", void 0);
__decorate([
    property({ type: String })
], InputText.prototype, "size", void 0);
__decorate([
    property({ type: String })
], InputText.prototype, "variant", void 0);
InputText = __decorate([
    localized(),
    customElement('input-text')
], InputText);
export { InputText };
//# sourceMappingURL=InputText.js.map